import Box, { BoxProps } from '@material-ui/core/Box';
import React from 'react';

const DataGridContainer = (props: BoxProps) => <Box height="60vh" width="100%" {...props} />;

export default DataGridContainer;
